import { createSlice } from '@reduxjs/toolkit';

import {
  AddReelAction,
  DeleteReelAction,
  LoadListAction,
  LoadReelsAction,
  ReelsState,
  SendViewAction,
  SetActiveIndexAction,
  SetCanUploadReelAction,
  SetDeleteReelAction,
  SetListAction,
  SetListLoadingStatusAction,
  SetReelsAction,
  SetTabBadgeAction,
  ToggleLikeAction,
  RestoreReelAction,
  UpdateReelAction,
  ReportReelAction,
  SetUserFollows,
  DeleteUserFollow,
} from './interface';
import { RootState } from '$store/rootReducer';
import { getStorageItem } from '$utils';

const initialState: ReelsState = {
  loadingStatus: '',
  reels: [],
  canUploadReel: false,
  hasTabBadge: getStorageItem('reelsBadgeHidden') !== 'true',
  activeIndex: 0,
  userFollows: [],
  listReels: {},
  listReelsStartFrom: {},
  listLoadingStatus: {},
  listActiveIndex: {},
};

export const { actions, reducer } = createSlice({
  name: 'reels',
  initialState,
  reducers: {
    addReel(state, action: AddReelAction) {
      state.reels = [action.payload, ...state.reels];
    },
    loadReels(state, action: LoadReelsAction) {
      if (action.payload.replace) {
        state.activeIndex = 0;
      }
      state.loadingStatus = 'loading';
      if (action.payload.replace) {
        state.reels = [];
      }
    },
    setCanUploadReel(state, action: SetCanUploadReelAction) {
      state.canUploadReel = action.payload;
    },
    setReels(state, action: SetReelsAction) {
      state.loadingStatus = '';
      state.reels = action.payload;
    },
    setReelsFailed(state) {
      state.loadingStatus = 'failed';
    },
    setUserFollows(state, action: SetUserFollows) {
      state.userFollows = action.payload;
    },
    deleteUserFollow(state, action: DeleteUserFollow) {
      state.userFollows = state.userFollows.filter((id) => id !== action.payload);
    },
    toggleLike(_, __: ToggleLikeAction) {},
    deleteReel(_, __: DeleteReelAction) {},
    restoreReel(_, __: RestoreReelAction) {},
    setDeleteReel(state, action: SetDeleteReelAction) {
      const { reelId, isDelete } = action.payload;
      for (let i = 0; i < state.reels.length; i++) {
        if (state.reels[i].id === reelId) {
          state.reels[i].isDeleted = isDelete;
          break;
        }
      }
    },
    updateReel(state, action: UpdateReelAction) {
      const { reelId, updated, ownerId } = action.payload;
      for (let i = 0; i < state.reels.length; i++) {
        if (state.reels[i].id === reelId) {
          state.reels[i] = {
            ...state.reels[i],
            ...updated,
          };
          break;
        }
      }
      if (!state.listReels[`profile_${ownerId}`]) {
        return;
      }
      for (let i = 0; i < state.listReels[`profile_${ownerId}`].length; i++) {
        if (state.listReels[`profile_${ownerId}`][i].id === reelId) {
          state.listReels[`profile_${ownerId}`][i] = {
            ...state.listReels[`profile_${ownerId}`][i],
            ...updated,
          };
          break;
        }
      }
    },
    reportReel(_, __: ReportReelAction) {},
    sendView(_, __: SendViewAction) {},
    setTabBadge(state, action: SetTabBadgeAction) {
      state.hasTabBadge = action.payload;
    },
    reset(state) {
      state.reels = [];
      state.activeIndex = 0;
    },
    setActiveIndex(state, action: SetActiveIndexAction) {
      state.activeIndex = action.payload;
    },
    loadList(state, action: LoadListAction) {
      if (action.payload.replace) {
        state.listActiveIndex[action.payload.list] = 0;
        state.listReels[action.payload.list] = [];
      }
      state.listLoadingStatus[action.payload.list] = 'loading';
    },
    setListLoadingStatus(state, action: SetListLoadingStatusAction) {
      state.listLoadingStatus[action.payload.list] = action.payload.status;
    },
    setList(state, action: SetListAction) {
      if (action.payload.replace) {
        state.listReels[action.payload.list] = action.payload.reels;
      } else {
        state.listReels[action.payload.list] = [
          ...state.listReels[action.payload.list],
          ...action.payload.reels,
        ];
      }
      state.listReelsStartFrom[action.payload.list] = action.payload.startFrom;
    },
  },
});

export { reducer as reelsReducer, actions as reelsActions };

export const reelsSelector = (state: RootState) => state.reels;

export const reelsUserFollowsSelector = (state: RootState) => state.reels.userFollows;

export const reelsLoadingStatusSelector = (state: RootState) => state.reels.loadingStatus;
export const reelsItemsSelector = (state: RootState) => state.reels.reels;
export const canUploadReelSelector = (state: RootState) => state.reels.canUploadReel;
export const reelsBadgeSelector = (state: RootState) => state.reels.hasTabBadge;
export const reelsActiveIndexSelector = (state: RootState) => state.reels.activeIndex;
export const listReelsByIdSelector = (state: RootState, userId) =>
  state.reels.listReels[`profile_${userId}`] ?? [];

export const listReelsStartFromByIdSelector = (state: RootState, userId) =>
  state.reels.listReelsStartFrom[`profile_${userId}`] ?? 0;

export const listReelsLoadingStatusSelector = (state: RootState, userId) =>
  state.reels.listLoadingStatus[`profile_${userId}`];
